import { render, staticRenderFns } from "./ExogenaInformation.vue?vue&type=template&id=4c9f27a9&scoped=true"
import script from "./ExogenaInformation.vue?vue&type=script&lang=js"
export * from "./ExogenaInformation.vue?vue&type=script&lang=js"
import style0 from "./ExogenaInformation.vue?vue&type=style&index=0&id=4c9f27a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f27a9",
  null
  
)

export default component.exports